import { useEffect } from 'react';
import TagManager from 'react-gtm-module';


const GTM_ID = process.env.REACT_APP_GTM_ID || 'GTM-5M4R782M';

const GTMProvider = ({ children }) => {
console.log(GTM_ID)
    useEffect(() => {
        if (GTM_ID) {
            TagManager.initialize({ gtmId: GTM_ID });
        }
    }, [])

    return children;
}

export default GTMProvider;
